import { Pipe, PipeTransform } from '@angular/core';
import { lastWord } from 'shared/utils';

@Pipe({
  name: 'lastWord'
})
export class LastWordPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return lastWord(value as string);
  }

}
